document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const select = form.querySelector('[name="id"]');
    const price = form.querySelector('[data-price]');
    const button = form.querySelector('[type="submit"]');
    if (!select) return;
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (button) {
        button.disabled = option.dataset.available !== 'true';
        button.textContent = option.dataset.available === 'true' ? button.dataset.addText : button.dataset.soldText;
      }
    });
  });
});
